import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { useScreenSize } from 'hooks/useScreenSize';
import { useSelector } from 'hooks/useSelector';
import { ScreenSize } from 'lib/constants';
import { str } from 'lib/str';
import * as React from 'react';
import { Platform } from 'react-native';
import { useDispatch } from 'react-redux';
import { doSetSettingSavePhotosToMediaLibrary } from 'store/actions';
import { selectSettingSavePhotosToMediaLibrary } from 'store/app/selectors';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.SETTINGS],
  Screens.SettingsGeneral
>;

export const GeneralSettingsScreen: React.FC<Props> = ({ navigation }) => {
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const settingSavePhotosToMediaLibrary = useSelector(
    selectSettingSavePhotosToMediaLibrary,
  );

  return (
    <PageScrollView
      isInModal={false}
      header={
        <NavigationHeader
          heading="App Settings"
          onPressBackButton={
            screenSize === ScreenSize.large ? undefined : navigation.goBack
          }
        />
      }
    >
      {Platform.OS !== 'web' && (
        <Card
          label="Media"
          explanation={`Backup photos taken with RiskBase by saving them to your device${str.apos}s media library`}
        >
          <CardRow
            label="Save Photos to Media Library"
            switchValue={!!settingSavePhotosToMediaLibrary}
            onSwitchChange={() =>
              dispatch(
                doSetSettingSavePhotosToMediaLibrary({
                  enable: !settingSavePhotosToMediaLibrary,
                  ask: true,
                }),
              )
            }
          />
        </Card>
      )}
    </PageScrollView>
  );
};
